import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import axiosClient from "./api/axiosClient";

const firebaseConfig = {
    apiKey: "AIzaSyCt9MpEpYD7k5l7c_2Aei5dNUAw2qvoZwg",
    authDomain: "sawaripakistan-6330e.firebaseapp.com",
    projectId: "sawaripakistan-6330e",
    storageBucket: "sawaripakistan-6330e.firebasestorage.app",
    messagingSenderId: "809784423993",
    appId: "1:809784423993:web:0840348e7c23e48724bfe8",
    measurementId: "G-F1HH37274C"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const requestForToken = async (role) => {
    try {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
            const token = await getToken(messaging, {
                vapidKey: "BCUP8rqYu8sDxxKsN1Tjmr3rs-e5TNKJ6iNZAw_WWc9vNJy04MrU5LXVqVVL9KQJ8z-qRyMiVN4-wLam8VJ_PpE",
            });

            console.log("Firebase Token:", token);

            // Send token to the backend
            await axiosClient.patch("/user/save-token",
                { fcm_token: token }, // Request body
            );

            await axiosClient.post("/user/subscribe", {
                token,
                topic: "broadcast", // Change topic name as needed
            });



            if (role > 1) {
                await axiosClient.post("/user/subscribe", {
                    token,
                    topic: "broadcast-non-admin-dashboard", // Change topic name as needed
                });
            }

            return token;
        } else {
            console.log("Notification permission denied.");
        }
    } catch (error) {
        console.error("Error getting Firebase token", error);
    }
};

export const onMessageListener = () =>
    new Promise((resolve) => {
        onMessage(messaging, (payload) => {
            console.log("Message received:", payload);
            resolve(payload);
        });
    });
